import config from 'js/app/config';

import type { TestimonialItemType } from 'bundles/cds-labs/components/Modules/TestimonialsModule/TestimonialItem';

import _t from 'i18n!nls/cds-labs';

const getDefaultTestimonials = (): Array<TestimonialItemType> => {
  return [
    {
      name: 'Felipe M.',
      learnerSince: 2018,
      imageSrc: `${config.url.resource_assets}growth_testimonials/passionate_learner/Felipe_Moitta.png`,
      quote: _t(
        'To be able to take courses at my own pace and rhythm has been an amazing experience. I can learn whenever it fits my schedule and mood.'
      ),
    },
    {
      name: 'Jennifer J.',
      learnerSince: 2020,
      imageSrc: `${config.url.resource_assets}growth_testimonials/passionate_learner/Jennifer_John.png`,
      quote: _t(
        'I directly applied the concepts and skills I learned from my courses to an exciting new project at work.'
      ),
    },
    {
      name: 'Larry W.',
      learnerSince: 2021,
      imageSrc: `${config.url.resource_assets}growth_testimonials/passionate_learner/Larry_Tao_Wang_1.png`,
      quote: _t(
        `When I need courses on topics that my university doesn't offer, Coursera is one of the best places to go.`
      ),
    },
    {
      name: 'Chaitanya A.',
      imageSrc: `${config.url.resource_assets}growth_testimonials/passionate_learner/Chaitanya_Anand.png`,
      quote: _t(
        `Learning isn't just about being better at your job: it's so much more than that. Coursera allows me to learn without limits.`
      ),
    },
  ];
};

export default getDefaultTestimonials;
